import { render, staticRenderFns } from "./TicketNotes.vue?vue&type=template&id=050a554e&"
import script from "./TicketNotes.vue?vue&type=script&lang=js&"
export * from "./TicketNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports